module.exports = __webpack_public_path__ + "img/bike.8b9b1c5b.svg";